module.exports = __webpack_public_path__ + "static/media/mattedWovenBag.d754bcc6.svg";